import React, { useState } from 'react'
import { Form, Button } from 'react-bootstrap'

const ItemCreateForm = () => {

  const [errText, setErrText] = useState()
  const [imgSrc, setImgSrc] = useState()
  const [itemName, setItemName] = useState()
  const [itemCategory, setItemCategory] = useState()
  const [itemSubcategory, setItemSubcategory] = useState()
  const [itemPrice, setItemPrice] = useState()

  return (
    <Form  style={{boxShadow: "0 0 32px 2px lightgray"}} onSubmit={(e) => console.log(e)} className='p-4 w-100 m-auto'>
      <Form.Group className="mb-3" controlId="formImgSrc">
        <Form.Label>Image URL</Form.Label>
        <Form.Control className='py-2 px-3 fs-5' onChange={e => setImgSrc(e.target.value)} required type="text" placeholder="image.example.com" />
      </Form.Group>
      <Form.Group className="mb-3" controlId="formItemName">
        <Form.Label>Item Name</Form.Label>
        <Form.Control className='py-2 px-3 fs-5' onChange={e => setItemName(e.target.value)} required type="text" placeholder="Standing Desk" />
      </Form.Group>
      <Form.Group className='d-flex flex-column mt-4'>
        <Form.Label>Choose a Category</Form.Label>
        <div>
          {["0","1","2","3","4","5","6"].map(x => <Form.Check
            inline
            key={x}
            label={x}
            name="group1"
            type="radio"
            id={`inline-${x}`}
            />)}
        </div>
      </Form.Group>
      <Form.Group className='d-flex flex-column mt-4'>
        <Form.Label>Choose a Subcategory</Form.Label>
        <div>
          {["0","1","2"].map(x => <Form.Check
            inline
            key={x}
            label={x}
            name="group1"
            type="radio"
            id={`inline-${x}`}
            />)}
        </div>
      </Form.Group>
      <Form.Group className="mt-4" controlId="formPrice">
        <Form.Label>Price - <span className='text-danger'>$</span> </Form.Label>
        <Form.Control className='py-2 px-3 fs-5' onChange={e => setItemName(e.target.value)} step="0.01" required type="number" placeholder="0.00" />
      </Form.Group>
      <Form.Group className="mt-4" controlId="formQuantity">
        <Form.Label>Quantity in Inventory</Form.Label>
        <Form.Control className='py-2 px-3 fs-5' onChange={e => setItemName(e.target.value)} step="1" required type="number" placeholder="0" />
      </Form.Group>
      <p className='text-danger' id="sign-in-error-text">{errText}</p>
      <Button disabled={false} className='py-2 w-100 px-5 mt-3 fs-4' variant="outline-dark" type="submit">
        Submit
      </Button>
    </Form>
  )
}

export default ItemCreateForm